<template>
    <v-row
        no-gutters
        align="center"
        class="flex-nowrap"
    >
        <v-col>
            <v-btn
                elevation="0"
                style="border-radius: 5px 0 0 5px"
                min-width="40"
                min-height="40"
                :disabled="isBackDisabled()"
                class="px-0"
                @click="goBack"
            >
                <v-icon color="grey">
                    mdi-chevron-left
                </v-icon>
            </v-btn>
        </v-col>
        <v-col>
            <v-btn
                elevation="0"
                tile
                :disabled="isListDisabled()"
                min-width="40"
                min-height="40"
                class="px-0"
                @click="goToList"
            >
                <v-icon color="grey">
                    mdi-menu
                </v-icon>
            </v-btn>
        </v-col>
        <v-col>
            <v-btn
                elevation="0"
                style="border-radius: 0 5px 5px 0"
                :disabled="isForwardDisabled()"
                min-width="40"
                min-height="40"
                class="px-0"
                @click="goForward"
            >
                <v-icon color="grey">
                    mdi-chevron-right
                </v-icon>
            </v-btn>
        </v-col>
    </v-row>
</template>

<script>

import {onMounted, ref} from "@vue/composition-api";
import {Router} from "@/composables/Router";
import UrlAdapter from "@/urlAdapter/urlAdapter";
import ClientModule from "../../store/modules/client";

export default {
    name: "AppToolbarTracking",
    setup() {
        const router = Router();
        const urlAdapter = new UrlAdapter();
        const clientModule = ClientModule()
        const cache = ref([]);

        const getCache = () => {
            return cache.value;
        }

        const getListIds = async (query) => {
            let params = urlAdapter.convertQueryStringToParamsObject(query)
            params.as_sorted_ids = true
            return await clientModule.fetchClients(params)
        }

        const updateCache = async () => {
            let _cache = JSON.parse(localStorage.getItem("cached_list"))
            if (_cache && !_cache.list) {
                let result = await getListIds(_cache.query)
                _cache.list = result['sorted_ids']
                localStorage.setItem("cached_list", JSON.stringify(_cache));
            }

            cache.value = _cache
        }

        const getCurrentId = () => {
            return parseInt(router.currentRoute.params.id)
        }

        const setDisabled = (reference) => {
            reference.value = true
            setTimeout(() => {
                reference.value = false
            }, 600)
        }

        const listDisabled = ref(false)
        const isListDisabled = () => {
            return listDisabled.value
        }
        const goToList = () => {
            let cache = getCache()
            if (!cache || !cache.list) return
            setDisabled(listDisabled)
            router.push(cache['return_path'])
        }

        const backDisabled = ref(false)

        const isBackDisabled = () => {
            return backDisabled.value || getPreviousId() === getCurrentId()
        }
        const getPreviousId = () => {
            let cache = getCache()
            if (!cache || !cache.list) return
            let current_id = getCurrentId()
            let current_id_index = cache.list.findIndex(id => id === current_id)
            let previous_id = current_id_index - 1 >= 0 ? current_id_index - 1 : current_id_index
            return cache.list[previous_id]
        }
        const goBack = () => {
            let cache = getCache()
            if (!cache || !cache.list) return
            setDisabled(backDisabled)
            router.push({name: cache['route_name'], params: {id: getPreviousId()}})
        }


        const forwardDisabled = ref(false)
        const isForwardDisabled = () => {
            return forwardDisabled.value || getNextId() === getCurrentId()
        }
        const getNextId = () => {
            let cache = getCache()
            if (!cache || !cache.list) return
            let current_id = getCurrentId()
            let current_id_index = cache.list.findIndex(id => id === current_id)
            let next_index = current_id_index + 1 <= cache.list.length - 1 ? current_id_index + 1 : current_id_index
            return cache.list[next_index]
        }
        const goForward = () => {
            let cache = getCache()
            if (!cache || !cache.list) return
            setDisabled(forwardDisabled)
            router.push({name: cache['route_name'], params: {id: getNextId()}})
        }

        onMounted(() => {
            updateCache()
        })

        return {
            goBack,
            goToList,
            goForward,
            getPreviousId,
            getNextId,
            getCurrentId,
            isBackDisabled,
            isListDisabled,
            isForwardDisabled
        };
    }
};
</script>
